module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "header flex flex-between"
  }, [_c('div', {
    staticClass: "lef"
  }, [_c('router-link', {
    staticClass: "header-logo flex",
    attrs: {
      "to": {
        path: '/index/home'
      },
      "tag": "div"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-right": "2px"
    },
    attrs: {
      "src": require("../assets/images/zaitaxiang.svg"),
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chat",
    on: {
      "click": _vm.toChat
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/images/logo-chat.png"),
      "alt": ""
    }
  }), _vm._v("\n        Ai工作助手\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "rig flex"
  }, [_c('div', {
    staticClass: "tab-item flex m-r-36",
    on: {
      "click": _vm.toNotice
    }
  }, [_c('img', {
    staticClass: "t-icon",
    attrs: {
      "src": require("../assets/images/icon_msg.png"),
      "alt": "logo"
    }
  }), _vm._v("\n        消息\n      ")]), _vm._v(" "), (_vm.hrinfo) ? _c('span', {
    staticClass: "short-line m-r-36"
  }) : _vm._e(), _vm._v(" "), (_vm.hrinfo) ? _c('div', {
    staticClass: "tab-item flex m-r-36",
    staticStyle: {
      "cursor": "default"
    }
  }, [(!_vm.hrinfo.headImage) ? _c('img', {
    staticClass: "t-face",
    attrs: {
      "src": require("../assets/images/face.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "t-face",
    attrs: {
      "src": _vm.hrinfo.headImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span"
  }, [_vm._v(_vm._s(((_vm.hrinfo.name) + "/" + (_vm.hrinfo.companyShortname))))])]) : _vm._e(), _vm._v(" "), (_vm.hrinfo) ? _c('el-dropdown', {
    on: {
      "command": _vm.onCommand
    }
  }, [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-down"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "goPerson"
    },
    on: {
      "click": _vm.goPerson
    }
  }, [_vm._v("个人信息")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "logout"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.hrinfo) ? _c('div', {
    staticClass: "content flex align-start"
  }, [(_vm.targetShow) ? _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "menu-height"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "active",
      "to": {
        path: '/index/home'
      },
      "tag": "dd"
    }
  }, [_c('img', {
    staticClass: "ac",
    attrs: {
      "src": require("../assets/images/right-nav/user_a.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "df",
    attrs: {
      "src": require("../assets/images/right-nav/user.png"),
      "alt": ""
    }
  }), _vm._v("\n          我的桌面\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "active",
      "to": {
        path: '/index/resume/list'
      },
      "tag": "dd"
    }
  }, [_c('img', {
    staticClass: "ac",
    attrs: {
      "src": require("../assets/images/right-nav/solution_a.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "df",
    attrs: {
      "src": require("../assets/images/right-nav/solution.png"),
      "alt": ""
    }
  }), _vm._v("\n          简历管理\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "active",
      "to": {
        path: '/index/posts'
      },
      "tag": "dd"
    }
  }, [_c('img', {
    staticClass: "ac",
    attrs: {
      "src": require("../assets/images/right-nav/wrench_a.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "df",
    attrs: {
      "src": require("../assets/images/right-nav/wrench.png"),
      "alt": ""
    }
  }), _vm._v("\n          岗位管理\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "active",
      "to": {
        path: '/index/jobfair'
      },
      "tag": "dd"
    }
  }, [_c('img', {
    staticClass: "ac",
    attrs: {
      "src": require("../assets/images/right-nav/id_card_a.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "df",
    attrs: {
      "src": require("../assets/images/right-nav/id_card.png"),
      "alt": ""
    }
  }), _vm._v("\n          招聘会\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "active",
      "to": {
        path: '/index/album'
      },
      "tag": "dd"
    }
  }, [_c('img', {
    staticClass: "ac",
    attrs: {
      "src": require("../assets/images/right-nav/image_a.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "df",
    attrs: {
      "src": require("../assets/images/right-nav/image.png"),
      "alt": ""
    }
  }), _vm._v("\n          企业相册\n        ")]), _vm._v(" "), (_vm.hrinfo.role === 1) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "active",
      "to": {
        path: '/index/staff'
      },
      "tag": "dd"
    }
  }, [_c('img', {
    staticClass: "ac",
    attrs: {
      "src": require("../assets/images/right-nav/cluster_a.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "df",
    attrs: {
      "src": require("../assets/images/right-nav/cluster.png"),
      "alt": ""
    }
  }), _vm._v("\n          组织架构\n        ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "active",
      "to": {
        path: '/index/finance'
      },
      "tag": "dd"
    }
  }, [_c('img', {
    staticClass: "ac",
    attrs: {
      "src": require("../assets/images/right-nav/money_a.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "df",
    attrs: {
      "src": require("../assets/images/right-nav/money.png"),
      "alt": ""
    }
  }), _vm._v("\n          财务管理\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "active",
      "to": {
        path: '/index/member/info'
      },
      "tag": "dd"
    }
  }, [_c('img', {
    staticClass: "ac",
    attrs: {
      "src": require("../assets/images/right-nav/crown_a.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "df",
    attrs: {
      "src": require("../assets/images/right-nav/crown.png"),
      "alt": ""
    }
  }), _vm._v("\n          会员特权\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "active",
      "to": {
        path: '/index/company'
      },
      "tag": "dd"
    }
  }, [_c('img', {
    staticClass: "ac",
    attrs: {
      "src": require("../assets/images/right-nav/setting_a.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "df",
    attrs: {
      "src": require("../assets/images/right-nav/setting.png"),
      "alt": ""
    }
  }), _vm._v("\n          企业设置\n        ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-right",
    class: {
      'content-ling-right': !_vm.targetShow
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    on: {
      "pwd-modify": _vm.pwdModify
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "show": _vm.modalshow,
      "modal-title": "修改登录密码"
    },
    on: {
      "cancelHander": _vm.cancel,
      "conformHander": _vm.conform
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "ztx-mess-item"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ztx-mess-name"
  }, [_vm._v("旧密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPass),
      expression: "oldPass"
    }],
    staticClass: "ztx-mess-inp",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "请输入旧密码"
    },
    domProps: {
      "value": (_vm.oldPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPass = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ztx-mess-tx"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ztx-mess-item clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ztx-mess-name"
  }, [_vm._v("新密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "ztx-mess-inp",
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ztx-mess-tx"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ztx-mess-item clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ztx-mess-name"
  }, [_vm._v("重复输入")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repetPass),
      expression: "repetPass"
    }],
    staticClass: "ztx-mess-inp",
    attrs: {
      "type": "password",
      "placeholder": "请再次输入新密码"
    },
    domProps: {
      "value": (_vm.repetPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repetPass = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ztx-mess-tx"
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3b45e72","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = 914
// module chunks = 1